class CartDiscountCode extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector(".wt-cart__discount__input");
    this.submitButton = this.querySelector(".wt-cart__discount__submit");
    this.errorWrapper = this.querySelector(".wt-cart__discount__error");
    this.errorText = this.errorWrapper?.querySelector(".error-message");
    this.errorMessage = this.dataset.errorMessage;
    this.codes = (this.dataset.codes || "")
      .split(",")
      .map((code) => code.trim())
      .filter(Boolean);

    this.submitButton.addEventListener("click", (e) => {
      e.preventDefault();
      this.applyCode();
    });

    this.input.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        this.applyCode();
      }
    });

    this.querySelectorAll(".wt-cart__discount__remove").forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        this.removeCode(button.dataset.code);
      });
    });
  }

  setLoading(isLoading) {
    this.classList.toggle("wt-cart__discount--loading", isLoading);
    this.submitButton.disabled = isLoading;
  }

  showError(message) {
    if (!this.errorWrapper) return;
    this.errorText.textContent = message || "";
    this.errorWrapper.classList.toggle("hidden", !message);
  }

  applyCode() {
    const code = this.input.value.trim();
    if (!code) return;

    const nextCodes = Array.from(new Set([...this.codes, code]));
    this.updateDiscounts(nextCodes, code);
  }

  removeCode(code) {
    const nextCodes = this.codes.filter((existing) => existing !== code);
    this.updateDiscounts(nextCodes);
  }

  updateDiscounts(codes, addedCode) {
    this.showError("");
    this.setLoading(true);

    const cartDrawerItems = document.querySelector("cart-drawer-items");
    const sections = cartDrawerItems
      ? cartDrawerItems.getSectionsToRender().map((section) => section.section)
      : ["cart-drawer", "cart-icon-bubble"];

    const body = JSON.stringify({
      discount: codes.join(","),
      sections,
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((state) => {
        if (state.errors) {
          this.showError(this.errorMessage);
          return;
        }

        if (cartDrawerItems && state.sections) {
          cartDrawerItems.getSectionsToRender().forEach((section) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(state.sections[section.section], "text/html")
              .querySelector(section.selector)?.innerHTML;
            const target =
              document
                .getElementById(section.id)
                ?.querySelector(section.selector) ||
              document.getElementById(section.id);

            if (target && typeof sectionInnerHTML !== "undefined") {
              target.innerHTML = sectionInnerHTML;
            }
          });
        }

        if (addedCode) {
          const refreshed = document.querySelector("cart-discount-code");
          const appliedCodes = (refreshed?.dataset.codes || "")
            .split(",")
            .map((c) => c.trim().toLowerCase())
            .filter(Boolean);

          if (!appliedCodes.includes(addedCode.trim().toLowerCase())) {
            refreshed?.showError?.(this.errorMessage);
          }
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-discount-code" });
      })
      .catch(() => {
        this.showError(this.errorMessage);
      })
      .finally(() => {
        this.setLoading(false);
      });
  }
}

if (!customElements.get("cart-discount-code")) {
  customElements.define("cart-discount-code", CartDiscountCode);
}
